<template>
  <div class="recharge">
    <div class="inner">
      <div class="title">{{ $t("點數購買") }}</div>
      <div class="question">{{ $t("點數是什麼？") }}</div>
      <div class="answer">
        <p>
          {{ $t("玩家必須先儲值點數，方可在 購買元寶 頁面購買karos的元寶") }}
        </p>
        <p>{{ $t("儲值點數時，請先確認金額後再購買") }}</p>
      </div>
      <div class="products" v-if="pointArr.length > 0">
        <div
          class="products_item"
          v-for="(item, index) in pointArr"
          :key="index"
        >
          <img src="@/assets/img/mall/img_commodity01_Shopping.png" alt="" />
          <div class="item_title">{{ item.product }}</div>
          <div class="price">฿{{ item.price }}</div>
          <div class="buy-butt submit">
            <el-button type="primary" @click="buy(item)" style="width: 100%">{{
              $t("購買")
            }}</el-button>
          </div>
        </div>
      </div>
      <Nodata v-else />
    </div>
  </div>
</template>
<script>
import { pointProduct } from "@/api/mall";
import {
  getPaySign,
  getPaymentMethods,
  postRecharge,
  approval,
} from "@/api/pay";
import { getUserInfo } from "@/api/login";
import { mapState } from "vuex";
import pangpay from "@/utils/pangpay";
import Cookie from "js-cookie";
import { accountBase } from "@/utils/paccount";
import filters from "@/utils/filters";
const payment_methods = [
//   "inicis_VBank",
//   "inicis_HPP",
  // 'payco',
  // 'kakao',
  // 'naver',
//   "inicis",
  // 'mycard',
  'paypal',
  'razer',
];
export default {
  data() {
    return {
      pointArr: [],
      payment_methods: payment_methods,
      buyingItem: {},
      rechargerecord_id: "",
      userInfo: {},
    };
  },
  created() {
    this.getData();
    this.getSign();
    this.getPayments();
    this.$store.dispatch("getUser");
  },
  computed: {
    ...mapState({
      paySign: (state) => state.pay.paySign,
    }),
  },
  methods: {
    originPriceFormat: filters.priceFormat,
    async getData() {
      const res = await pointProduct({ limit: 99999 });
      this.pointArr = res.data.results;
    },
    async getPayments() {
      const res = await getPaymentMethods();
      this.payment_methods = res.data;
    },
    async getSign() {
      const res = await getPaySign();
      if (
        !this.paySign ||
        this.paySign.timestamp < new Date().getTime() / 1000 - 3000
      ) {
        this.$store.commit("SET_PAYSIGN", res.data);
        pangpay.createPangPayIframe(res.data);
      } else {
        pangpay.createPangPayIframe({ payment_methods: payment_methods });
      }
    },
    async buy(item) {
      this.buyingItem = item;
      const res = await getUserInfo();
      try {
        Cookie.set("userInfo", res.data);
        this.$store.commit("SET_USERINFO");
        this.userInfo = res.data;
      } catch {
        Cookie.remove("userInfo");
        Cookie.remove("token");
        window.localStorage.setItem("return_url", this.$route.fullPath);
        location.href =
          this.$store.state.header.app_oauth2 +
          `/#/login?client_id=${this.$store.state.header.app_account_client_id}&return_url=${this.$store.state.header.app_redirect_url}`;
      }
      pangpay.createPangPay(
        {
          price: item.price,
          subDescription: item.price
            ? `Point: ${this.originPriceFormat(item.point)}`
            : null,
          currency: "THB",
          product: item.product,
          realname: this.userInfo.realname,
          phone: this.userInfo.phone,
          buyeremail: this.userInfo.email,
          payment_methods: this.payment_methods.map((x) => x),
          showItems: item.point?[
            {
              label: this.$t("持有點數："),
              value: `${this.originPriceFormat(
                this.userInfo.total_point
              )} ${this.$t("點")}`,
            },
            {
              label: this.$t("儲值點數："),
              value: `${this.originPriceFormat(item.point)} ${this.$t("點")}`,
            },
            {
              label: this.$t("儲值後點數："),
              value: `${this.originPriceFormat(
                this.userInfo.total_point + item.point
              )} ${this.$t("點")}`,
            },
          ]:[
                        {
                            label: '',
                            value: this.$t('点卡金额不能少于 THB 50'),
                        }
                    ],
        },
        this.submit,
        this.approve
      );
    },
    async submit(data) {
      const res = await postRecharge({
        payment_method: data.payment_method,
        channel_id: data.channel_id,
        pointproduct: this.buyingItem.id,
        is_mobile: data.isMobile,
      });
      if (res.status == 201) {
        this.rechargerecord_id = res.data.id;
        res.data.returnUrl =
          this.$baseUrl + "/rechargerecords/" + res.data.id + "/pay";
        res.data.redirectUrl = "/shop/record?isnew=true&id=" + res.data.id;
        pangpay.submitRecord(res.data);
        this.$store.commit('SET_CURRENTTYPE', '3')
        this.$router.push(`/mall?id=${res.data.id}`)
      } else {
        this.$message.error(res.data);
      }
    },
    async approve(data) {
      if (data) {
        const res = await approval(this.rechargerecord_id, data);
        if (res.status === 200) {
          this.$router.push(`/mall?id=${this.rechargerecord_id}`);
          this.$store.commit("SET_CURRENTTYPE", 3);
        } else {
          this.$message.error(res.data);
        }
      }
    },
    gotoAuth() {
      let token = Cookie.get("token");
      if (token) {
        window.open(
          accountBase + "/#/mypage/userdata?ctab=2&token=" + token,
          "_blank"
        );
      } else {
        this.$router.replace("/account/login");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.recharge {
  .inner {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    text-align: left;
    @media only screen and (max-width: 900px) {
      width: 100%;
    }
    .title {
      font-size: 48px;
      color: #000;
      margin: 38px 0;
      @media only screen and (max-width: 900px) {
        font-size: 24px;
        color: #000;
        margin: 19px 0;
      }
    }
    .question {
      font-size: 22px;
      color: #c6a86c;
      margin: 15px 0;
      @media only screen and (max-width: 900px) {
        font-size: 14px;
        margin: 19px 0;
      }
    }
    .answer {
      font-size: 18px;
      margin: 0 0;
      line-height: 29px;
      @media only screen and (max-width: 900px) {
        font-size: 14px;
        line-height: 1.2;
      }
      p {
        @media only screen and (max-width: 900px) {
          margin: 16px 0;
        }
      }
    }
    .products {
      display: flex;
      align-items: flex-start;
      margin-top: 40px;
      margin-bottom: 100px;
      flex-wrap: wrap;
      @media only screen and (max-width: 900px) {
        margin-top: 20px;
        margin-bottom: 50px;
      }
      .products_item {
        width: 260px;
        height: 289px;
        background: #fff;
        text-align: center;
        margin-bottom: 25px;
        margin-right: 25px;
        @media only screen and (max-width: 900px) {
          margin: 0 auto;
          margin-top: 10px;
          margin-bottom: 12px;
          width: 260px;
          height: 289px;
        }
        img {
          width: 87px;
          height: 87px;
          margin: 24px;
          @media only screen and (max-width: 900px) {
            width: 87px;
            height: 87px;
            margin: 24px;
          }
        }
        .item_title {
          font-size: 28px;
          color: #c6a86c;
          padding-bottom: 20px;
          @media only screen and (max-width: 900px) {
            font-size: 24px;
          }
        }
        .price {
          font-size: 18px;
          color: #616161;
          line-height: 32px;
          @media only screen and (max-width: 900px) {
            font-size: 18px;
            line-height: 32px;
          }
        }
        .buy-butt {
          line-height: 40px;
          width: 75%;
          background: #c6a86c;
          border-radius: 4px;
          text-align: center;
          color: #fff;
          margin: auto;
          cursor: pointer;
          font-weight: 400;
          @media only screen and (max-width: 900px) {
            line-height: 40px;
          }
        }
      }
    }
  }
}
</style>
